import { render, staticRenderFns } from "./TypographyTypographicScaleSection.vue?vue&type=template&id=1b44f09f"
import script from "./TypographyTypographicScaleSection.vue?vue&type=script&lang=ts"
export * from "./TypographyTypographicScaleSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyTypographicScaleSection.vue?vue&type=style&index=0&id=1b44f09f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports